import React from 'react';
import './About.css';

const differentiators = [
  { icon: '🎥', title: 'Producción Audiovisual de Alto Impacto' },
  { icon: '🌐', title: 'Estrategias Digitales + SEO' },
  { icon: '🤖', title: 'CRM y Automatización con IA' }
];

const About = () => { // Keeping the name 'About' to avoid changing App.js
  return (
    <section className="trust-section py-5">
      <div className="container">
        <div className="row text-center">
          {differentiators.map((item, index) => (
            <div className="col-lg-4 mb-4 mb-lg-0" key={index}>
              <div className="trust-icon">{item.icon}</div>
              <h5 className="fw-bold mt-3">{item.title}</h5>
            </div>
          ))}
        </div>
        <div className="text-center mt-5">
          <p className="h5 fw-light">
            <span className="fw-bold">Más de 18 años</span> de experiencia — <span className="fw-bold">Más de 300</span> proyectos realizados
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
